<template>
  <section id="section-biography" ref="sectionBiography">
    <div id="biography-content" ref="testAnchor">
      <div class="biography-text" :style="textStyle">
        <h3 :style="textStyle">Biography</h3>
        <div v-if="global.mainPage.biography" v-html="global.mainPage.biography"></div>
      </div>
      <div class="biography-accords">
        <h4 :style="textStyle">Filmography</h4>
        <div class="accord">
          <AccordionItem
            v-if="televisionItems"
            :propsArray="televisionItems"
            :itemId="'television'"
            :active="activeItemKey === 'television'"
            :title="'Television'"
            :icon="require('@/assets/images/icons/television.svg')"
          />
        </div>
        <div>
          <AccordionItem
            v-if="filmItems"
            :propsArray="filmItems"
            :itemId="'film'"
            :active="activeItemKey === 'film'"
            :title="'Film'"
            :icon="require('@/assets/images/icons/film.svg')"
          />
        </div>
        <div>
          <AccordionItem
            v-if="videoItems"
            :propsArray="videoItems"
            :itemId="'musicVideo'"
            :active="activeItemKey === 'musicVideo'"
            :title="'Commercial & Music Video'"
            :icon="require('@/assets/images/icons/video.svg')"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from "vuex";
import AccordionItem from "@/components/global/AccordionItem";
import { TweenLite } from "gsap/dist/gsap";
import * as ScrollMagic from "scrollmagic";
import { TimelineLite } from "gsap/all";
import { ScrollMagicPluginGsap } from "scrollmagic-plugin-gsap";
ScrollMagicPluginGsap(ScrollMagic, TimelineLite);

import { gsap, CSSPlugin } from "gsap/all";
gsap.registerPlugin(CSSPlugin);

export default {
  name: "Biography",
  components: {
    AccordionItem
  },
  data() {
    return {
      activeItemKey: "television",
      tween: new TimelineLite({ paused: true }),
      scene: new ScrollMagic.Scene({
        triggerElement: this.$refs.sectionBiography,
        triggerHook: "onEnter",
        duration: 1400,
        offset: 0
      }),
      controller: new ScrollMagic.Controller(),
      televisionItems: [],
      filmItems: [],
      videoItems: []
    };
  },
  computed: {
    ...mapState(["global"]),
    secondaryFontColor(){
      return `--green_font: ${this.$store.getters.themeSettings.secondary_font_color};`;
    },
    mainFontColor(){
      return `--main_font: ${this.$store.getters.themeSettings.main_font_color};`;
    },
    headerTitleFontSize(){
      return `--header_title_font_size: ${this.$store.getters.fontSettings.header_title.font_size}px;`;
    },
    headerTitleFontStyle(){
      return `--header_title_font_family: "${this.$store.getters.fontSettings.header_title.font_style}";`;
    },
    textStyle() {
      return `${this.secondaryFontColor} ${this.mainFontColor} ${this.headerTitleFontSize} ${this.headerTitleFontStyle}`;
    },
  },
  mounted() {
    this.initDropDowns();

    this.scene = new ScrollMagic.Scene({
      triggerElement: this.$refs.sectionBiography,
      triggerHook: "onEnter",
      duration: 1400,
      offset: 0
    });
    this.addScrollMagicEffects();

    // let that = this;
    // let adjustParalaxEffects = this.debounce(function() {
    //   that.addScrollMagicEffects();
    // }, 250);

    // window.addEventListener("resize", adjustParalaxEffects);
  },
  methods: {
    initDropDowns() {
      if (this.global.mainPage.television_repeater) {
        let televisionArray = this.convertLinkOrCollection(
          this.global.mainPage.television_repeater
        );
        this.televisionItems = televisionArray;
      }
      if (this.global.mainPage.film_repeater) {
        this.filmItems = this.convertLinkOrCollection(
          this.global.mainPage.film_repeater
        );
      }
      if (this.global.mainPage.video_repeater) {
        this.videoItems = this.convertLinkOrCollection(
          this.global.mainPage.video_repeater
        );
      }
    },
    convertLinkOrCollection(array) {
      return array.map(item => {
        let itemUrl = "#";
        if (item.link_or_collection && item.link_or_collection.length > 0) {
          if (
            item.link_or_collection[0].acf_fc_layout === "collection_item" &&
            item.link_or_collection[0].collection_item
          ) {
            itemUrl =
              process.env.VUE_APP_FRONT_END_URL +
              "/collection/" +
              item.link_or_collection[0].collection_item;
            item.targetLocal = true;
          } else if (
            item.link_or_collection[0].acf_fc_layout === "url" &&
            item.link_or_collection[0].url
          ) {
            itemUrl = item.link_or_collection[0].url;
          }
        }

        item.url = itemUrl;
        return item;
      });
    },
    itemClicked(itemId, refresh) {
      let currentActiveEle = document.getElementById(this.activeItemKey);
      let activeItemKeyCopy = this.activeItemKey;

      if (currentActiveEle && !(refresh && activeItemKeyCopy !== itemId)) {
        this.activeItemKey = "";
        TweenLite.to(currentActiveEle, 0.5, {
          height: 0
        });
      }

      if (
        (itemId != activeItemKeyCopy && !refresh) ||
        (refresh && activeItemKeyCopy === itemId)
      ) {
        this.activeItemKey = itemId;
        let newActiveEle = document.getElementById(itemId);
        TweenLite.to(newActiveEle, 0.5, {
          height: newActiveEle.scrollHeight
        });
      }
    },
    debounce(func, wait, immediate) {
      var timeout;
      return function() {
        var context = this,
          args = arguments;
        var later = function() {
          timeout = null;
          if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
      };
    },
    addScrollMagicEffects() {
      const header = this.$refs.testAnchor;

      // let heightToSet = 3300;

      let bioContent = document.getElementById("biography-content");
      bioContent.style.transform = "translate(0%,-125px)";

      // if (window.innerHeight > 1100) {
      //   heightToSet = 3300;
      //   bioContent.style.transform = "translate(0%,-3300px)";
      // } else if (window.innerHeight > 600) {
      //   heightToSet = 150;
      //   bioContent.style.transform = "translate(0%,-150)";
      // } else {
      //   heightToSet = 100;
      //   bioContent.style.transform = "translate(0%,-100)";
      // }
      // this.scene.removeTween().addTo(this.controller);
      this.scene
        .setTween(this.tween.to(header, 2, { translateY: `+=${125}` }, 0))
        .addTo(this.controller);
    },
    destroyParalax() {
      this.controller.destroy();
      this.scene.destroy();
      this.tween.kill();
      this.controller = null;
      this.scene = null;
      this.tween = null;
    }
  },

  beforeDestroy() {
    this.destroyParalax();
  }
};
</script>

<style lang="scss" scoped>
#section-biography {
  background: $black_overlay_rgba_dark;
  z-index: 3;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  #biography-content {
    display: flex;
    flex-direction: row;
    padding: 150px 100px 100px 100px;
    justify-content: center;
    color: #fff;
    transform: translate(0%, -125px);

    @media (max-width: 1175px) {
      flex-direction: column;
      align-items: center;
      padding: 100px 0 80px 0;
    }
    > div {
      flex: 1;
      display: flex;
      flex-direction: column;
      max-width: 100vw;
      width: 550px;
      @media (max-width: 1175px) {
        padding: 0 16px;
      }
    }
    .biography-text {
      justify-content: flex-start;
      margin-right: 12px;

      @media (max-width: 1175px) {
        margin-right: 0;
        margin-bottom: 60px;
      }
      h3 {
        font-family: "AvenirLTStd-Black";
        font-family: var(--header_title_font_family);
        font-size: 24px;
        font-size: var(--header_title_font_size);
        color: var(--green_font);
        line-height: 24px;
        margin-bottom: 32px;
        text-transform: uppercase;
        font-weight: bold;
      }
    }
    .biography-accords {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      margin-left: 12px;
      @media (max-width: 1175px) {
        margin-left: 0;
        margin-top: 24px;
      }
      .accord {
        padding-top: 14px;
      }
      h4 {
        font-family: "AvenirLTStd-Black";
        font-family: var(--header_title_font_family);
        font-size: 24px;
        font-size: var(--header_title_font_size);
        color: var(--green_font);
        line-height: 24px;
        align-self: flex-start;
        text-transform: uppercase;
        font-weight: bold;
      }
      > div {
        width: 100%;
      }
    }
  }
}
</style>

<style lang="scss">
strong {
  font-family: "AvenirLTStd-Heavy" !important;
}
.biography-text {
  p {
    color: var(--main_font);
    font-family: "AvenirLTStd-Roman";
    font-size: 16px;
    letter-spacing: 0;
    text-align: left;
    line-height: 24px;
    margin: 0;
  }
}
</style>